/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const Screen = styled.div`
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
`;

export const Headline = styled.h1`
    width: 363px;
    margin: 0;
    padding: 0;

    font-family: "Custora";
    font-weight: 400;
    font-size: 36px;
    line-height: 130%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #e9ecf5;
`;

export const Subhead = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;
`;

export const PromptText = styled.p`
    margin: 0;
    padding: 0px;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;
`;

export const EmailStrong = styled.span`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #e9ecf5;
`;

export const FullWidth = styled.div`
    width: 100%;
`;

export const Card = styled.div`
    width: 100%;
    background: #1e1f22;
    border: 1px solid #2b2d33;
    border-radius: 12px;
    box-shadow: 0px 2px 6px 0px #10243e1f;
    padding: 16px;
    box-sizing: border-box;
`;

export const ContinueButton = styled.button`
    width: 100%;
    height: 48px;

    background: #5e84ed;
    border: none;
    border-radius: 10px;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 44.61px;
    letter-spacing: 0px;
    text-align: center;

    color: #ffffff;

    cursor: pointer;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const ForgotLink = styled.button`
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    width: 100%;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #5e84ed;

    cursor: pointer;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const ErrorText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    text-align: center;

    color: #ff8a8a;
`;

export const SpinnerWrap = styled.div`
    margin-top: 12px;
    display: grid;
    place-items: center;
`;
